<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style="animation: svg-touch-animation-0 2s infinite;">
        <g fill="currentColor" fill-rule="evenodd">
            <path
                    d="M19.499 31C23.642 31 27 27.415 27 23.5c0 0 0 2.313 0 0v-5.998a1.5 1.5 0 10-3 0V18h-1v-2.494a1.5 1.5 0 10-3 0V17h-1v-2.494a1.5 1.5 0 10-3 0V18h-1V7.505a1.499 1.499 0 10-3 0V18.8c-2.058-2.2-4.768-4.62-5.879-3.504-1.087 1.093 1.714 4.105 5.626 10.687C13.51 28.95 15.74 31 19.5 31zM28 23.5a8.5 8.5 0 01-8.5 8.5c-3.113 0-6.398-1.453-8.66-5.572-3.263-5.945-7.436-9.845-5.449-11.832 1.422-1.422 3.654-.058 5.609 1.77V7.509a2.5 2.5 0 115 0v4.99A2.493 2.493 0 0117.5 12c1.083 0 1.995.677 2.346 1.628.44-.39 1.02-.628 1.654-.628 1.39 0 2.5 1.118 2.5 2.498v.013a2.495 2.495 0 011.5-.497c1.39 0 2.5 1.12 2.5 2.5z" />
            <path
                    style="opacity: 0; animation: svg-touch-animation-1 2s infinite;"
                    d="M16.99 10.34a4.5 4.5 0 10-7 0V7.505a3.494 3.494 0 013.5-3.492c1.928 0 3.5 1.563 3.5 3.492z" />
            <path
                    style="opacity: 0; animation: svg-touch-animation-2 2s infinite;"
                    d="M18.804 11.306a6.5 6.5 0 10-8.808 1.726v-1.236a5.5 5.5 0 117.736-.735c.377.025.737.11 1.072.245zm-7.06 14.73c-16.526 15.69-8.263 7.845 0 0zm-.907.445c-15.92 15.392-7.96 7.696 0 0z" />
        </g>
    </svg>
</template>

<style>
    @-webkit-keyframes svg-touch-animation-0 {
        0% {
            transform: scale(1.05) translateY(3px);
        }
        25% {
            transform: scale(1) translateY(0px);
        }
        50% {
            transform: scale(1) translateY(0px);
        }
        100% {
            transform: scale(1.05) translateY(3px);
        }
    }
    @-webkit-keyframes svg-touch-animation-1 {
        0% {
            opacity: 0;
        }
        15% {
            opacity: 0;
        }
        40% {
            opacity: 1;
        }
        65% {
            opacity: 0;
        }
        80% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }
        @-webkit-keyframes svg-touch-animation-2 {
        0% {
            opacity: 0;
        }
        25% {
            opacity: 0;
        }
        50% {
            opacity: 1;
        }
        75% {
            opacity: 0;
        }
        90% {
            opacity: 0;
        }
    }
</style>

<script>
// https://www.iconfinder.com/icons/329390/double_finger_gesture_hand_tap_icon
export default {
    props: {
        animated: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {

    },
};
</script>

